import { ToggleFireCOAutomatedTests } from "src/components/SettingsProfiles/FireCOAlarm/ToggleFireCOAutomatedTests"
import { EditType, IEditFieldNode } from "src/data/editField/editFieldTypes"
import { TProfileSettings } from "src/data/homeProfileSettings/types/homeProfilesSettingTypes"

export const AutomatedTestsNode: IEditFieldNode<TProfileSettings> = {
  type: EditType.NODE,
  key: "fire-co-automated-tests",
  contents: (s) => <ToggleFireCOAutomatedTests profile={s.profile} />,
}
